import { callUIAPI } from './apiUtils';
import { METHOD_GET, METHOD_POST } from './apiUtilsConstants';
export const getCurrentSubscription = async (fresh = false) => {
  const path = fresh ? 'firms/subscription/current?fresh=1' : 'firms/subscription/current';
  return callUIAPI(path, undefined, METHOD_GET, true);
};
export const getSubscriptionPlans = async () => {
  return callUIAPI('firms/subscription/plans', undefined, METHOD_GET, true);
};
export const changeSubscription = async (newPriceId) => {
  return callUIAPI('firms/subscription/change', { newPriceId }, METHOD_POST, true);
};
export const cancelSubscription = async (subscriptionId) => {
  return callUIAPI('firms/subscription/cancel', { subscriptionId }, METHOD_POST, true);
};
export const reactivateSubscription = async (subscriptionId) => {
  return callUIAPI('firms/subscription/reactivate', { subscriptionId }, METHOD_POST, true);
};
export const createUpdatePaymentMethodTransaction = async (subscriptionId) => {
  return callUIAPI('firms/subscription/update-payment-method', { subscriptionId }, METHOD_POST, true);
};
export const confirmPaymentMethodUpdate = async (subscriptionId, setupIntentId) => {
  return callUIAPI('firms/subscription/confirm-payment-method', { subscriptionId, setupIntentId }, METHOD_POST, true);
};
export const createSubscriptionTransaction = async (priceId) => {
  return callUIAPI('firms/subscription/create-transaction', { priceId }, METHOD_POST, true);
};
export const checkSubscriptionTransaction = async (transactionId) => {
  return callUIAPI('firms/subscription/check-transaction', { transactionId }, METHOD_POST, true);
};
export const revertSubscriptionChange = async (subscriptionId, originalState) => {
  return callUIAPI('firms/subscription/revert-change', { subscriptionId, originalState }, METHOD_POST, true);
};